import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { shallowEqual, useSelector } from 'react-redux';
import {
  ControlBar,
  CurrentTimeDisplay,
  ForwardControl,
  PlaybackRateMenuButton,
  Player,
  ReplayControl,
  TimeDivider,
  VolumeMenuButton,
} from 'video-react';

import { useSubheader } from '../../../_metronic/layout';
import { fetchTexts } from '../../../airtable/settings';

import 'video-react/dist/video-react.css';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'center',
    justifyItems: 'center',
    textAlign: 'center',
  },
}));

export default function HomePage() {
  const classes = useStyles();
  const subheader = useSubheader();
  subheader.setTitle('Home');

  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const userFullName = user.name.trim();
  const userFirstName = userFullName.split(' ')[0];

  const [text, setText] = useState(null);
  const [textColor, setTextColor] = useState(null);
  const [warning, setWarning] = useState(null);
  const [warningColor, setWarningColor] = useState(null);

  useEffect(() => {
    async function fetchAll() {
      const settings = await fetchTexts();

      setText(settings.get('home-top-center')
        .replace('{firstName}', userFirstName)
        .replace('{fullName}', userFullName));
      setTextColor(settings.get('home-top-center-color'));

      setWarning(settings.get('home-top-warning')
        .replace('{firstName}', userFirstName)
        .replace('{fullName}', userFullName));
      setWarningColor(settings.get('home-top-warning-color'));
    }

    void fetchAll();
  }, [userFirstName, userFullName]);

  function renderSpan(spanText, spanColor, className) {
    if (spanText) {
      return <>
        <span className={className} style={{ color: spanColor, whiteSpace: 'pre-line' }}>
          {spanText}
        </span>
        <br />
      </>;
    }
    return null;
  }

  return (
    <div className={classes.root}>
      {renderSpan(warning, warningColor, 'dci-title')}
      {renderSpan(text, textColor, 'dci-font')}
      <Player playsInline>
        <source type="video/mp4" src="https://dci-automation-welcome-video.s3.us-east-2.amazonaws.com/welcome.mp4" />
        <ControlBar autoHide={false}>
          <ReplayControl seconds={10} order={1.1} />
          <ForwardControl seconds={30} order={1.2} />
          <CurrentTimeDisplay order={4.1} />
          <TimeDivider order={4.2} />
          <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} order={7.1} />
          <VolumeMenuButton disabled />
        </ControlBar>
      </Player>
    </div>
  );
}
